import {makeAutoObservable, runInAction} from "mobx";
import {queryParams} from "../utils/queryParams";
import {safeLocalStorage} from "../utils/safeLocalStorage";

const TokenStorageKey = "token";
const RequestParamName = "token";
const CookieKey = "safecube_key_card";

class TokenStore {
	_token?: string;

	constructor() {
		makeAutoObservable(this);

		// initially push token
		this._token = processAndGetToken();

		// push token when the storage is updated from another document
		safeLocalStorage.onChange(TokenStorageKey, () => {
			runInAction(() => {
				this._token = safeLocalStorage.read(TokenStorageKey);
			});
		});
	}

	get token() {
		return this._token;
	}

	clearToken() {
		safeLocalStorage.remove(TokenStorageKey);
	}
}

export const tokenStore = new TokenStore();

function processAndGetToken() {
	// first, read the token from the request (route or query param)
	const tokenFromRequest = getTokenFromRoute() || queryParams.get(RequestParamName);
	if (tokenFromRequest) {
		// if there is one, write it to localStorage and return it
		safeLocalStorage.write(TokenStorageKey, tokenFromRequest);
		return tokenFromRequest;
	}

	// if there is a token in localStorage, we can return it
	const tokenFromLocalStorage = safeLocalStorage.read(TokenStorageKey);
	if (tokenFromLocalStorage) {
		return tokenFromLocalStorage;
	}

	// if there is a token in the legacy cookie, we migrate it to localStorage and return it
	const tokenFromCookie = getCookie(CookieKey);
	if (tokenFromCookie) {
		safeLocalStorage.write(TokenStorageKey, tokenFromCookie);
		return tokenFromCookie;
	}

	// otherwise, there is no token
	return undefined;
}

function getTokenFromRoute() {
	if (location.pathname.indexOf("/t/") === 0) {
		return location.pathname.substring(3);
	}
}

/**
 * Helper function to get the value of a cookie with the specified name.
 * @param name The cookie name.
 */
function getCookie(name: string) {
	const parts = ("; " + document.cookie).split("; " + name + "=");
	if (parts && parts.length == 2) {
		const part = parts.pop();
		if (part) {
			return part.split(";").shift();
		}
	}
	return undefined;
}
